// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1wR_w","card":"styles_card__30_At","header":"styles_header__OO0UO"};